import { makeStyles } from 'tss-react/mui';
import { AgentProfileItem } from '../../types/agent-profile-types';
import { useEffect, useState } from 'react';
import { fetchFloatingBanner } from '../../network/agentProfileCrud';
import * as _ from 'lodash';

type FloatingBannerProps = {
  agentProfile: AgentProfileItem;
  refreshBanner: boolean;
  isClickable:boolean;
  getBannerHight: (hight: number) => void;
};

const FloatingBanner = (props: FloatingBannerProps) => {
  const { classes } = useStyles();
  const isGIActive = _.get(props.agentProfile, 'agentDetail.license.gi', '') === 'Y';
  const isClickable = props.isClickable == true;
  const [floatingBanner, setFloatingBanner] = useState<any>(null);
  useEffect(() => {
    const shortenCode = props.agentProfile?.shortenCode;
    if (shortenCode) {
      fetchFloatingBanner(shortenCode)
        .then((resp) => {
          setFloatingBanner(resp?.data[0])
          if((isGIActive && resp?.data[0] != undefined)) {
            props.getBannerHight(100)
          }else {
            props.getBannerHight(0)
          }
        })
        .catch(() => {});
    }
  }, [props.agentProfile?.shortenCode, props.refreshBanner]);
  return <>
    {isGIActive && floatingBanner && (
      <div className={classes.floatingBanner}>
        <div className={classes.floatingBannerInner}>
          {isClickable ?
            (
              <a href={floatingBanner?.targetUrl} target="_blank" rel="noreferrer">
                <img className={classes.promotionBannerImg} src={floatingBanner?.imageUrl} alt="Promotion" />
              </a>
            ) : (
              <img className={classes.promotionBannerImg} src={floatingBanner?.imageUrl} alt="Promotion" />
            )
          }
        </div>
      </div>
    )}
  </>;
};
export default FloatingBanner;

const useStyles = makeStyles()(() => ({
  floatingBanner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 8,
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
  },
  floatingBannerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    boxShadow: '0px 4px 16px 0px #00000014',
  },
  promotionBannerImg: {
    maxHeight: 100,
    width: '100%',
  },
}));
